import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid, Checkbox, Divider } from '@material-ui/core'
import PropTypes from 'prop-types'
import Ws from '../../providers/Ws';
import Utils from '../../providers/Utils';
import SpecificComponent from '../../commons/SpecificComponent';
import ProgramCompanieZi from './ProgramCompanieZi';

import { ReactComponent as Trash } from '../../Pics/iconsManagementUtilizatori/Trash.svg';



export default class ProgramCompanie extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            programSelectat: null,
            programCompanie: []
        }
    }

    componentDidMount() {
        this.getProgramCompanie()
        // this.deleteProgram()
    }

    ws = new Ws()
    u = new Utils()


    deleteProgram = async (program) => {

        let deleteProgram = await this.ws.update('program_lucru', { sters: 1 }, { id: program.id })

        if (deleteProgram.Succes) {
            this.getProgramCompanie()
        }
    }

    getProgramCompanie = async () => {

        let getProgram = await this.ws.customSelect('select * from program_lucru where isnull(este_template,0)=1 and isnull(sters,0)!=1', {
            p1: 1
        })

        if (getProgram.Succes) {

            let programCompanie = [...getProgram.Content]

            for (let i = 0, n = programCompanie.length; i < n; i++) {

                programCompanie[i].lu_start = this.u.transformTimeFromSql(programCompanie[i].lu_start)
                programCompanie[i].lu_end = this.u.transformTimeFromSql(programCompanie[i].lu_end)
                programCompanie[i].ma_start = this.u.transformTimeFromSql(programCompanie[i].ma_start)
                programCompanie[i].ma_end = this.u.transformTimeFromSql(programCompanie[i].ma_end)
                programCompanie[i].mi_start = this.u.transformTimeFromSql(programCompanie[i].mi_start)
                programCompanie[i].mi_end = this.u.transformTimeFromSql(programCompanie[i].mi_end)
                programCompanie[i].jo_start = this.u.transformTimeFromSql(programCompanie[i].jo_start)
                programCompanie[i].jo_end = this.u.transformTimeFromSql(programCompanie[i].jo_end)
                programCompanie[i].vi_start = this.u.transformTimeFromSql(programCompanie[i].vi_start)
                programCompanie[i].vi_end = this.u.transformTimeFromSql(programCompanie[i].vi_end)
                programCompanie[i].sa_start = this.u.transformTimeFromSql(programCompanie[i].sa_start)
                programCompanie[i].sa_end = this.u.transformTimeFromSql(programCompanie[i].sa_end)
                programCompanie[i].du_start = this.u.transformTimeFromSql(programCompanie[i].du_start)
                programCompanie[i].du_end = this.u.transformTimeFromSql(programCompanie[i].du_end)


                programCompanie[i].lu_pauza_start = this.u.transformTimeFromSql(programCompanie[i].lu_pauza_start)
                programCompanie[i].lu_pauza_end = this.u.transformTimeFromSql(programCompanie[i].lu_pauza_end)
                programCompanie[i].ma_pauza_start = this.u.transformTimeFromSql(programCompanie[i].ma_pauza_start)
                programCompanie[i].ma_pauza_end = this.u.transformTimeFromSql(programCompanie[i].ma_pauza_end)
                programCompanie[i].mi_pauza_start = this.u.transformTimeFromSql(programCompanie[i].mi_pauza_start)
                programCompanie[i].mi_pauza_end = this.u.transformTimeFromSql(programCompanie[i].mi_pauza_end)
                programCompanie[i].jo_pauza_start = this.u.transformTimeFromSql(programCompanie[i].jo_pauza_start)
                programCompanie[i].jo_pauza_end = this.u.transformTimeFromSql(programCompanie[i].jo_pauza_end)
                programCompanie[i].vi_pauza_start = this.u.transformTimeFromSql(programCompanie[i].vi_pauza_start)
                programCompanie[i].vi_pauza_end = this.u.transformTimeFromSql(programCompanie[i].vi_pauza_end)
                programCompanie[i].sa_pauza_start = this.u.transformTimeFromSql(programCompanie[i].sa_pauza_start)
                programCompanie[i].sa_pauza_end = this.u.transformTimeFromSql(programCompanie[i].sa_pauza_end)
                programCompanie[i].du_pauza_start = this.u.transformTimeFromSql(programCompanie[i].du_pauza_start)
                programCompanie[i].du_pauza_end = this.u.transformTimeFromSql(programCompanie[i].du_pauza_end)
            }


            console.log('programCompanie :>> ', programCompanie);
            this.setState({
                programCompanie: programCompanie,
                programSelectat: programCompanie.length > 0 ? programCompanie[0] : null

            })
        }
    }


    addNewProgram = async () => {

        let program = {
            lu_start: '08:00',
            ma_start: '08:00',
            mi_start: '08:00',
            jo_start: '08:00',
            vi_start: '08:00',
            sa_start: '08:00',
            du_start: '08:00',
            lu_end: '18:00',
            ma_end: '18:00',
            mi_end: '18:00',
            jo_end: '18:00',
            vi_end: '18:00',
            sa_end: '18:00',
            du_end: '18:00',
            lu_pauza_start: '12:00',
            ma_pauza_start: '12:00',
            mi_pauza_start: '12:00',
            jo_pauza_start: '12:00',
            vi_pauza_start: '12:00',
            sa_pauza_start: '12:00',
            du_pauza_start: '12:00',
            lu_pauza_end: '12:30',
            ma_pauza_end: '12:30',
            mi_pauza_end: '12:30',
            jo_pauza_end: '12:30',
            vi_pauza_end: '12:30',
            sa_pauza_end: '12:30',
            du_pauza_end: '12:30',
            este_template: 1,
            nume_template: 'Program Nou'
        }


        let insertProgram = await this.ws.insert('program_lucru', program)


        if (insertProgram.Succes) {
            this.getProgramCompanie()
        }



    }


    changeProgram = (ev) => {

        let program = { ...this.state.programSelectat }


        let v = ev.target.value
        let n = ev.target.name


        program[n] = v

        this.setState({ programSelectat: program })
    }


    absent = (ev, zi) => {
        //    console.log('ev :', ev);

        //    console.log('zi :', zi);

        let oldState = { ...this.state.programSelectat }

        if (oldState[zi] === '00:00') {
            oldState[zi] = '09:00'
        } else {
            oldState[zi] = '00:00'
        }
        this.setState({
            programSelectat: oldState
        },
            () => {
                this.updateProgram()

            })
    }


    updateProgram = async () => {
        let program = {
            lu_start: this.state.programSelectat.lu_start,
            ma_start: this.state.programSelectat.ma_start,
            mi_start: this.state.programSelectat.mi_start,
            jo_start: this.state.programSelectat.jo_start,
            vi_start: this.state.programSelectat.vi_start,
            sa_start: this.state.programSelectat.sa_start,
            du_start: this.state.programSelectat.du_start,
            lu_end: this.state.programSelectat.lu_end,
            ma_end: this.state.programSelectat.ma_end,
            mi_end: this.state.programSelectat.mi_end,
            jo_end: this.state.programSelectat.jo_end,
            vi_end: this.state.programSelectat.vi_end,
            sa_end: this.state.programSelectat.sa_end,
            du_end: this.state.programSelectat.du_end,
            lu_pauza_start: this.state.programSelectat.lu_pauza_start,
            ma_pauza_start: this.state.programSelectat.ma_pauza_start,
            mi_pauza_start: this.state.programSelectat.mi_pauza_start,
            jo_pauza_start: this.state.programSelectat.jo_pauza_start,
            vi_pauza_start: this.state.programSelectat.vi_pauza_start,
            sa_pauza_start: this.state.programSelectat.sa_pauza_start,
            du_pauza_start: this.state.programSelectat.du_pauza_start,
            lu_pauza_end: this.state.programSelectat.lu_pauza_end,
            ma_pauza_end: this.state.programSelectat.ma_pauza_end,
            mi_pauza_end: this.state.programSelectat.mi_pauza_end,
            jo_pauza_end: this.state.programSelectat.jo_pauza_end,
            vi_pauza_end: this.state.programSelectat.vi_pauza_end,
            sa_pauza_end: this.state.programSelectat.sa_pauza_end,
            du_pauza_end: this.state.programSelectat.du_pauza_end,
            nume_template: this.state.programSelectat.nume_template
        }


        let updateProgram = await this.ws.update('program_lucru', program, { id: this.state.programSelectat.id })

        if (updateProgram.Succes) {
            // this.getProgramCompanie()
            let updateProgram = await this.ws.update('program_lucru', program, { id_template: this.state.programSelectat.id })


            if (updateProgram.Succes) {
                this.props.getData()
              
            }
        }

    }


    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    fullWidth={true}
                    disableEnforceFocus
                    maxWidth='md'
                    style={{
                        zIndex: 5100,
                    }}
                    open={this.props.open}
                    onClose={this.props.dialogClose}>
                    <DialogActions >
                        <Fab style={{
                            backgroundColor: 'transparent',
                            boxShadow: 'none'
                        }} onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i style={{ color: 'black', fontSize: 30 }} className='material-icons pm-round-button-text-dialog'>close</i>
                        </Fab>
                    </DialogActions>


                    <DialogContent>
                        <Grid container>
                            <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>

                                <Grid container>
                                    {this.state.programCompanie.map((p, idx) => {
                                        return (

                                            <Grid key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Grid container>
                                                    <Grid onClick={() => { this.setState({ programSelectat: p }) }} style={{ marginBottom: 20 }} item xs={10} sm={10} md={10} lg={10} xl={10}>
                                                        <span style={{ color: this.state.programSelectat && p.id === this.state.programSelectat.id ? 'rgb(38 120 227)' : 'black', cursor: 'pointer', fontWeight: 600 }}>{p.nume_template} </span>

                                                    </Grid>
                                                    <Grid style={{ marginBottom: 20 }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                        <Trash onClick={() => { this.deleteProgram(p) }} style={{ width: 20, height: 20, marginRight: 10, verticalAlign: 'middle', cursor: 'pointer' }} />

                                                    </Grid>
                                                </Grid>


                                            </Grid>


                                        )
                                    })}

                                    <Grid onClick={this.addNewProgram} item xs={10} sm={10} md={10} lg={10} xl={10}>
                                        <span style={{ color: 'rgb(38 120 227)', cursor: 'pointer' }}>
                                            <i style={{ verticalAlign: 'middle' }} className='material-icons'>add</i>
                                            {this.dictionary.managementUtilizatori.creeazaProgramNou}</span>

                                    </Grid>
                                </Grid>

                            </Grid>

                            <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>

                                {this.state.programSelectat &&

                                    <Grid container>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.managementUtilizatori.detaliiProgram} </h5>


                                        </Grid>

                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <div style={{ position: 'relative', textAlign: 'left' }}>
                                                <input
                                                    style={{ fontSize: 14, fontWeight: 400, width: '100%', }}
                                                    id='nume_template'
                                                    type="text"
                                                    step='any'
                                                    className='add-project-input'
                                                    placeholder={'Nume Program'}
                                                    margin="normal"
                                                    name='nume_template'
                                                    value={this.state.programSelectat.nume_template || ''}
                                                    onChange={this.changeProgram}
                                                    onBlur={this.updateProgram}
                                                />
                                                <label className='inputLabelPM' htmlFor='telefon'>{this.dictionary.managementUtilizatori.denumireProgram}</label>
                                            </div>
                                            <Divider style={{ marginTop: 20 }} className='pm-divider' />
                                        </Grid>

                                        <Grid style={{ paddingTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <h3 style={{
                                                marginBottom: 3, textAlign: 'right',
                                                marginBottom: 10,
                                                fontSize: 14
                                            }} className="pm-title">
                                                <Checkbox style={{
                                                    color: '#000000', padding: 0,
                                                }}
                                                    onChange={(ev) => { this.absent(ev, 'lu_start') }}
                                                    checked={this.state.programSelectat.lu_start === '00:00' ? false : true} />
                                                {this.dictionary.zileleSapt.luni}</h3>

                                            {this.state.programSelectat.lu_start !== '00:00' &&
                                                <ProgramCompanieZi
                                                    ziua={this.dictionary.zileleSapt.luni}
                                                    idStart={'lu_start'}
                                                    idEnd={'lu_end'}
                                                    valueStart={this.state.programSelectat.lu_start}
                                                    valueEnd={this.state.programSelectat.lu_end}
                                                    idPauzaStart={'lu_pauza_start'}
                                                    idPauzaEnd={'lu_pauza_end'}
                                                    valuePauzaStart={this.state.programSelectat.lu_pauza_start}
                                                    valuePauzaEnd={this.state.programSelectat.lu_pauza_end}
                                                    changeProgram={this.changeProgram}
                                                    updateProgram={this.updateProgram}
                                                />
                                            }
                                            {this.state.programSelectat.lu_start !== '00:00' &&
                                                <Divider style={{ marginTop: 20 }} className='pm-divider' />
                                            }
                                        </Grid>

                                        <Grid style={{ paddingTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                                            <h3 style={{
                                                marginBottom: 3, textAlign: 'right',
                                                marginBottom: 10,
                                                fontSize: 14
                                            }} className="pm-title">
                                                <Checkbox style={{
                                                    color: '#000000', padding: 0,
                                                }}
                                                    onChange={(ev) => { this.absent(ev, 'ma_start') }}
                                                    checked={this.state.programSelectat.ma_start === '00:00' ? false : true} />
                                                {this.dictionary.zileleSapt.marti}</h3>

                                            {this.state.programSelectat.ma_start !== '00:00' &&
                                                <ProgramCompanieZi
                                                    ziua={this.dictionary.zileleSapt.marti}
                                                    idStart={'ma_start'}
                                                    idEnd={'ma_end'}
                                                    valueStart={this.state.programSelectat.ma_start}
                                                    valueEnd={this.state.programSelectat.ma_end}
                                                    idPauzaStart={'ma_pauza_start'}
                                                    idPauzaEnd={'ma_pauza_end'}
                                                    valuePauzaStart={this.state.programSelectat.ma_pauza_start}
                                                    valuePauzaEnd={this.state.programSelectat.ma_pauza_end}
                                                    changeProgram={this.changeProgram}
                                                    updateProgram={this.updateProgram}
                                                />
                                            }
                                            {this.state.programSelectat.ma_start !== '00:00' &&
                                                <Divider style={{ marginTop: 20 }} className='pm-divider' />
                                            }
                                        </Grid>



                                        <Grid style={{ paddingTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                                            <h3 style={{
                                                marginBottom: 3, textAlign: 'right',
                                                marginBottom: 10,
                                                fontSize: 14
                                            }} className="pm-title">
                                                <Checkbox style={{
                                                    color: '#000000', padding: 0,
                                                }}
                                                    onChange={(ev) => { this.absent(ev, 'mi_start') }}
                                                    checked={this.state.programSelectat.mi_start === '00:00' ? false : true} />
                                                {this.dictionary.zileleSapt.miercuri}</h3>



                                            {this.state.programSelectat.mi_start !== '00:00' &&
                                                <ProgramCompanieZi
                                                    ziua={this.dictionary.managementUtilizatori.miercuri}
                                                    idStart={'mi_start'}
                                                    idEnd={'mi_end'}
                                                    valueStart={this.state.programSelectat.mi_start}
                                                    valueEnd={this.state.programSelectat.mi_end}
                                                    idPauzaStart={'mi_pauza_start'}
                                                    idPauzaEnd={'mi_pauza_end'}
                                                    valuePauzaStart={this.state.programSelectat.mi_pauza_start}
                                                    valuePauzaEnd={this.state.programSelectat.mi_pauza_end}
                                                    changeProgram={this.changeProgram}
                                                    updateProgram={this.updateProgram}
                                                />
                                            }
                                            {this.state.programSelectat.mi_start !== '00:00' &&

                                                <Divider style={{ marginTop: 20 }} className='pm-divider' />
                                            }
                                        </Grid>


                                        <Grid style={{ paddingTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                                            <h3 style={{
                                                marginBottom: 3, textAlign: 'right',
                                                marginBottom: 10,
                                                fontSize: 14
                                            }} className="pm-title">
                                                <Checkbox style={{
                                                    color: '#000000', padding: 0,
                                                }}
                                                    onChange={(ev) => { this.absent(ev, 'jo_start') }}
                                                    checked={this.state.programSelectat.jo_start === '00:00' ? false : true} />
                                                {this.dictionary.zileleSapt.joi}</h3>

                                            {this.state.programSelectat.jo_start !== '00:00' &&
                                                <ProgramCompanieZi
                                                    ziua={this.dictionary.zileleSapt.joi}
                                                    idStart={'jo_start'}
                                                    idEnd={'jo_end'}
                                                    valueStart={this.state.programSelectat.jo_start}
                                                    valueEnd={this.state.programSelectat.jo_end}
                                                    idPauzaStart={'jo_pauza_start'}
                                                    idPauzaEnd={'jo_pauza_end'}
                                                    valuePauzaStart={this.state.programSelectat.jo_pauza_start}
                                                    valuePauzaEnd={this.state.programSelectat.jo_pauza_end}
                                                    changeProgram={this.changeProgram}
                                                    updateProgram={this.updateProgram}
                                                />
                                            }


                                            {this.state.programSelectat.jo_start !== '00:00' &&
                                                <Divider style={{ marginTop: 20 }} className='pm-divider' />
                                            }

                                        </Grid>
                                        <Grid style={{ paddingTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>


                                            <h3 style={{
                                                marginBottom: 3, textAlign: 'right',
                                                marginBottom: 10,
                                                fontSize: 14
                                            }} className="pm-title">
                                                <Checkbox style={{
                                                    color: '#000000', padding: 0,
                                                }}
                                                    onChange={(ev) => { this.absent(ev, 'vi_start') }}
                                                    checked={this.state.programSelectat.vi_start === '00:00' ? false : true} />
                                                {this.dictionary.zileleSapt.vineri}</h3>


                                            {this.state.programSelectat.vi_start !== '00:00' &&
                                                <ProgramCompanieZi
                                                    ziua={this.dictionary.zileleSapt.vineri}
                                                    idStart={'vi_start'}
                                                    idEnd={'vi_end'}
                                                    valueStart={this.state.programSelectat.vi_start}
                                                    valueEnd={this.state.programSelectat.vi_end}
                                                    idPauzaStart={'vi_pauza_start'}
                                                    idPauzaEnd={'vi_pauza_end'}
                                                    valuePauzaStart={this.state.programSelectat.vi_pauza_start}
                                                    valuePauzaEnd={this.state.programSelectat.vi_pauza_end}
                                                    changeProgram={this.changeProgram}
                                                    updateProgram={this.updateProgram}
                                                />
                                            }

                                            {this.state.programSelectat.vi_start !== '00:00' &&
                                                <Divider style={{ marginTop: 20 }} className='pm-divider' />
                                            }
                                        </Grid>
                                        <Grid style={{ paddingTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>


                                            <h3 style={{
                                                marginBottom: 3, textAlign: 'right',
                                                marginBottom: 10,
                                                fontSize: 14
                                            }} className="pm-title">
                                                <Checkbox style={{
                                                    color: '#000000', padding: 0,
                                                }}
                                                    onChange={(ev) => { this.absent(ev, 'sa_start') }}
                                                    checked={this.state.programSelectat.sa_start === '00:00' ? false : true} />
                                                {this.dictionary.zileleSapt.sambata}</h3>

                                            {this.state.programSelectat.sa_start !== '00:00' &&
                                                <ProgramCompanieZi
                                                    ziua={this.dictionary.zileleSapt.sambata}
                                                    idStart={'sa_start'}
                                                    idEnd={'sa_end'}
                                                    valueStart={this.state.programSelectat.sa_start}
                                                    valueEnd={this.state.programSelectat.sa_end}
                                                    idPauzaStart={'sa_pauza_start'}
                                                    idPauzaEnd={'sa_pauza_end'}
                                                    valuePauzaStart={this.state.programSelectat.sa_pauza_start}
                                                    valuePauzaEnd={this.state.programSelectat.sa_pauza_end}
                                                    changeProgram={this.changeProgram}
                                                    updateProgram={this.updateProgram}
                                                />
                                            }
                                            {this.state.programSelectat.sa_start !== '00:00' &&
                                                <Divider style={{ marginTop: 20 }} className='pm-divider' />
                                            }
                                        </Grid>

                                        <Grid style={{ paddingTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                                            <h3 style={{
                                                marginBottom: 3, textAlign: 'right',
                                                marginBottom: 10,
                                                fontSize: 14
                                            }} className="pm-title">
                                                <Checkbox style={{
                                                    color: '#000000', padding: 0,
                                                }}
                                                    onChange={(ev) => { this.absent(ev, 'du_start') }}
                                                    checked={this.state.programSelectat.du_start === '00:00' ? false : true} />
                                                {this.dictionary.zileleSapt.duminica}</h3>

                                            {this.state.programSelectat.du_start !== '00:00' &&
                                                <ProgramCompanieZi
                                                    ziua={this.dictionary.zileleSapt.duminica}
                                                    idStart={'du_start'}
                                                    idEnd={'du_end'}
                                                    valueStart={this.state.programSelectat.du_start}
                                                    valueEnd={this.state.programSelectat.du_end}
                                                    idPauzaStart={'du_pauza_start'}
                                                    idPauzaEnd={'du_pauza_end'}
                                                    valuePauzaStart={this.state.programSelectat.du_pauza_start}
                                                    valuePauzaEnd={this.state.programSelectat.du_pauza_end}
                                                    changeProgram={this.changeProgram}
                                                    updateProgram={this.updateProgram}
                                                />
                                            }
                                            {this.state.programSelectat.du_start !== '00:00' &&
                                                <Divider style={{ marginTop: 20 }} className='pm-divider' />
                                            }
                                        </Grid>

                                        <Grid style={{ paddingTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <Button
                                           

                                                className={'add-button-green'} onClick={this.getProgramCompanie}  >

                                                 Salveaza
                                            </Button>
                                        </Grid>
                                    </Grid>
                                }

                                {!this.state.programSelectat &&

                                    <Grid container>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.managementUtilizatori.nuExistaProgram} </h5>

                                            <Divider className='pm-divider' />
                                        </Grid>




                                    </Grid>
                                }




                            </Grid>

                        </Grid>
                    </DialogContent>




                </Dialog>
            </div>
        );
    }
}

// end class


ProgramCompanie.propTypes = {
    open: PropTypes.bool,
    dialogClose: PropTypes.func,
    limba: PropTypes.object,
    absent: PropTypes.func,
    angajat: PropTypes.object,
    changeProgram: PropTypes.func,


}